/*
 * Shared building blocks for our own product pages, in the 09.57.34 / 10.03.13
 * language: a "<Product> · <Stage>" chip, a row of benefit cards and a slim
 * "why it matters" band. The chip is used by Health scores, Recommendations and
 * Analytics (blue in every mockup, so `tone` no longer changes its colour);
 * BenefitRow and WhyStrip only by the shelved AI Video page (kept on disk,
 * unimported).
 */
import './ProductDetail.css';

export function ProductChip({ icon: Icon, name, stage, tone = 'deliver' }) {
  return (
    <p className={`pill pd-chip pd-chip--${tone}`}>
      <span className="pd-chip__icon" aria-hidden="true">
        <Icon size={14} strokeWidth={2.6} aria-hidden="true" />
      </span>
      {name}
      <span className="pd-chip__stage">{` · ${stage}`}</span>
    </p>
  );
}

export function BenefitRow({ items, label }) {
  return (
    <ul className="pd-benefits" aria-label={label}>
      {items.map(({ key, icon: Icon, tone, title, text }) => (
        <li key={key} className="pd-benefit">
          <span className={`icon-tile icon-tile--${tone} pd-benefit__icon`} aria-hidden="true">
            <Icon size={22} strokeWidth={2.2} aria-hidden="true" />
          </span>
          <span>
            <strong>{title}</strong>
            <span>{text}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}

export function WhyStrip({ id, icon: Icon, title, children }) {
  return (
    <section className="pd-why" aria-labelledby={id}>
      <span className="pd-why__icon" aria-hidden="true">
        <Icon size={24} strokeWidth={2.2} aria-hidden="true" />
      </span>
      <div>
        <h2 id={id} className="pd-why__title">
          {title}
        </h2>
        <p className="pd-why__text">{children}</p>
      </div>
    </section>
  );
}
